import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import { Actions, Mutations } from "@/store/enums/StoreEnums";

export interface StoreInfo {
  classes: {
    header?: Array<string>;
    headerContainer?: Array<string>;
    headerMobile?: Array<string>;
    headerMenu?: Array<string>;
    aside?: Array<string>;
    asideMenu?: Array<string>;
    asideToggle?: Array<string>;
    toolbar?: Array<string>;
    toolbarContainer?: Array<string>;
    content?: Array<string>;
    contentContainer?: Array<string>;
    footerContainer?: Array<string>;
    sidebar?: Array<string>;
    pageTitle?: Array<string>;
  };
}

@Module
export default class BodyModule extends VuexModule implements StoreInfo {
  classes = {};
  timeout = 0;
  interval: number | undefined;

  /**
   * Get current page title
   * @returns string
   */
  get getClasses() {
    return (position) => {
      if (typeof position !== "undefined") {
        return this.classes[position];
      }
      return this.classes;
    };
  }

  get getTimeout() {
    return this.timeout;
  }

  @Mutation
  [Mutations.SET_CLASSNAME_BY_POSITION](payload) {
    const { position, className } = payload;
    if (!this.classes[position]) {
      this.classes[position] = [];
    }
    this.classes[position].push(className);
  }

  @Mutation
  [Mutations.SET_TIMEOUT](timeout: number) {
    this.timeout = timeout;
  }

  @Mutation
  [Mutations.SET_INTERVAL_VALUE](interval: number | undefined) {
    this.interval = interval;
  }

  @Mutation
  [Mutations.CLEAR_INTERVAL_VALUE]() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  @Action
  [Actions.ADD_BODY_CLASSNAME](className) {
    document.body.classList.add(className);
  }

  @Action
  [Actions.REMOVE_BODY_CLASSNAME](className) {
    document.body.classList.remove(className);
  }

  @Action
  [Actions.ADD_BODY_ATTRIBUTE](payload) {
    const { qulifiedName, value } = payload;
    document.body.setAttribute(qulifiedName, value);
  }

  @Action
  [Actions.REMOVE_BODY_ATTRIBUTE](payload) {
    const { qulifiedName } = payload;
    document.body.removeAttribute(qulifiedName);
  }

  @Action
  [Actions.ADD_CLASSNAME](payload) {
    this.context.commit(Mutations.SET_CLASSNAME_BY_POSITION, payload);
  }

  @Action
  [Actions.START_INTERVAL](timeout: number) {
    if (timeout < 0)
      return;

    if (timeout === 0) {
      this.context.commit(Mutations.CLEAR_INTERVAL_VALUE);
      this.context.commit(Mutations.SET_INTERVAL_VALUE, null);
      this.context.commit(Mutations.SET_TIMEOUT, 0);
      return;
    }

    this.context.commit(Mutations.SET_TIMEOUT, timeout);
    const newInterval = setInterval(() => {
      timeout--;
      if (timeout < 0) {
        return;
      }

      this.context.commit(Mutations.SET_TIMEOUT, timeout);
    }, 1000);

    this.context.commit(Mutations.CLEAR_INTERVAL_VALUE);
    this.context.commit(Mutations.SET_INTERVAL_VALUE, newInterval);
  }
}
